<template>
  <div>
    <div>
      {{ organisation_unit }}<span v-if="hasAdditionalOUs">; {{ additionalOUs }}</span>
    </div>

    <div>
      <strong>
        {{ title }}
      </strong>
    </div>

    <div v-if="hasBeginDate">
      <em>
        <translate>Kooperation.compact.beginn</translate>
      </em>: {{ beginDate }}
    </div>

    <div v-if="hasEnded">
      <em>
        <translate>Kooperation.compact.ende</translate>
      </em>: {{ endDate }}
    </div>

    <div v-if="hasExternalOrganisations">
      <em>
        <translate>Kooperation.compact.beteiligteOrganisationen</translate>
      </em>:
      {{ externalOrganisations }}
    </div>

    <div v-if="hasInvolvedPeople">
      <em>
        <translate>Kooperation.compact.beteiligtePersonen</translate>
      </em>:
      {{ involvedPeople }}
    </div>

  </div>
</template>

<script>
import DateTimeHelper from '@/components/mixins/DateTimeHelper'
import CompactViewHelper from '@/components/mixins/CompactViewHelper'

export default {
  name: 'fob-kooperation-compact',
  mixins: [DateTimeHelper, CompactViewHelper],
  props: ['schema', 'data'],
  computed: {
    organisation_unit () {
      return this.data.organisationseinheit.name
    },
    title () {
      return this.data.titelKooperation
    },
    hasBeginDate () {
      return this.data.beginn != null
    },
    beginDate () {
      return this.asDate(this.data.beginn)
    },
    hasEnded () {
      return this.data.ende != null
        ? (new Date() > this.data.ende)
        : false
    },
    endDate () {
      return this.asDate(this.data.ende)
    },
    hasExternalOrganisations () {
      return this.data.beteiligteOrganisationen != null && this.data.beteiligteOrganisationen.length > 0
    },
    externalOrganisations () {
      return this.data.beteiligteOrganisationen.map(this.externalOrgaRep).join('; ')
    },
    hasInvolvedPeople () {
      return this.involvedPeople !== ''
    },
    involvedPeople () {
      let persons = []
      if (this.data.ansprechpartner != null) {
        persons = persons.concat(this.data.ansprechpartner)
      }
      if (this.data.beteiligtePersonen != null) {
        persons = persons.concat(this.data.beteiligtePersonen)
      }
      persons = persons.reduce((acc, x) => acc.map(x => x._id).includes(x._id) ? acc : acc.concat(x), [])
      return persons.map(this.fullName).join('; ')
    },
    hasAdditionalOUs () {
      return this.data.weitereOrganisationseinheiten != null && this.data.weitereOrganisationseinheiten.length > 0
    },
    additionalOUs () {
      return this.data.weitereOrganisationseinheiten.map(x => x.name).join('; ')
    }
  },
  methods: {
    externalOrgaRep (xorga) {
      let land = xorga.land
      let landname
      if (land != null) {
        landname = this.currentLocale === 'de' ? land.nameDE : land.nameEN
      }

      let location = [xorga.stadt, landname].filter(x => x != null)
      return location.length === 0 ? xorga.name : `${xorga.name} (${location.join(', ')})`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/compact/Kooperation.vue